import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Message } from 'primereact/message'; 

import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioHttp from '../servicios/ServicioHttp';
import servicioFormatos from '../servicios/ServicioFormatos';
import servicioArchivos from '../servicios/ServicioArchivos';

export class ConsultaCfdiTelepeajeUsuario extends Component {

    constructor() {
        super();
        this.state = {
            inicio: 0,
            paginacion: {
                registrosPorPagina: 20,
                join: { "ttCfdi": "alias_ttCfdi" },
                restriccionesDinamicas: [
                ]
            },
            restricionPricipal: {
                tipoRestriccion: "isNotNull",
                nombrePropiedad: "alias_ttCfdi.uuid"
            },
            restricciones: {},
            errores:{}
        };
    }

    agregarRestriccionPrincipal = () => {
        let { paginacion, restricionPricipal } = this.state;
        var item = paginacion.restriccionesDinamicas.find(item => item.tipoRestriccion === "isNotNull");
        if (servicioAsignacionValoresObjetos.esObjetoVacio(item)) {
            paginacion.restriccionesDinamicas.push(restricionPricipal);
        }
    }

    obtenerCfdi = () => {
        this.agregarRestriccionPrincipal();
        let { paginacion } = this.state;
        servicioHttp.consumirPostHttp('/detalle_layout_telepeaje/consultar.json', paginacion).then(response => {
            this.setState({
                paginacion: response.data.objeto
            });
        }).catch(error => {

        });
    }

    buscar = () => {        
        let { paginacion, restricciones} = this.state;
        let errores={};
        if(servicioAsignacionValoresObjetos.esObjetoVacio(restricciones.idCuenta)){            
            errores.idCuenta="El atributo Id Cuenta es requerido";            
        }
        if(servicioAsignacionValoresObjetos.esObjetoVacio(restricciones.idCliente)){            
            errores.idCliente="El atributo Id Cliente es requerido";            
        }
        if(servicioAsignacionValoresObjetos.esObjetoVacio(restricciones.rfc)){            
            errores.rfc="El atributo Rfc Cliente es requerido";            
        }
        this.setState({errores:errores});
        if(servicioAsignacionValoresObjetos.esObjetoVacio(errores)){
            if (!servicioAsignacionValoresObjetos.esObjetoVacio(restricciones.idCuenta)) {
                paginacion.restriccionesDinamicas.push({
                    tipoRestriccion: "eq",
                    nombrePropiedad: "idCuenta",
                    valorPropiedad: restricciones.idCuenta
                });
            }

            if (!servicioAsignacionValoresObjetos.esObjetoVacio(restricciones.idCliente)) {
                paginacion.restriccionesDinamicas.push({
                    tipoRestriccion: "eq",
                    nombrePropiedad: "idCliente",
                    valorPropiedad: restricciones.idCliente
                });
            }

            if (!servicioAsignacionValoresObjetos.esObjetoVacio(restricciones.rfc)) {
                paginacion.restriccionesDinamicas.push({
                    tipoRestriccion: "eq",
                    nombrePropiedad: "rfc",
                    valorPropiedad: restricciones.rfc
                });
            }
            this.obtenerCfdi();
        }            
    }

    asignarValoresObjeto = (event) => {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);
    }

    cambiaPagina = (event) => {
        let { paginacion, restricciones } = this.state;
       // if(!servicioAsignacionValoresObjetos.esObjetoVacio(restricciones)){
            paginacion.numeroPagina = event.page;
            paginacion.registrosPorPagina = event.rows;
            this.setState({ inicio: event.first, paginacion });
            this.buscar();
        //}
        
    }

    templateColumnaFecha = (rowData, column) => {
        return servicioFormatos.formatearFecha(rowData.fechaCertificacion);
    }

    templateColumnaTotal = (rowData, column) => {
        return servicioFormatos.formatearModena(rowData.total);
    }

    templateXml = (rowData, column) => {
        return <Button icon="pi-md-file-download" className="p-button-success" onClick={() => this.descargaArchivo(rowData.id, 'xml')} />;
    }

    templatePdf = (rowData, column) => {
        return <Button icon="pi-md-file-download" className="p-button-danger" onClick={() => this.descargaArchivo(rowData.id, 'pdf')} />;
    }

    descargaArchivo = (id, tipo) => {
        servicioArchivos.descargaArchivo('/detalle_layout_telepeaje/descarga_documento.json?id=' + id + '&tipo=' + tipo);
    }

    render() {
        let { restricciones, paginacion, inicio, errores } = this.state;
        return (
            <div className="p-fluid">                
                <div className="card">
                    <div className="p-grid">
                        <div className="p-col-12">
                            <h1>Consulta mis Cfdi IAVE</h1>
                            <p>En esta sección usted puede consultar sus cfdi de IAVE es necesario contar con los siguientes datos para poder consultar sus facturas IAVE.</p>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <h1></h1>    
                    <div className="p-grid">
                        <div className="p-col-12 p-md-3">
                            <span className="md-inputfield">
                                <InputText className={errores.idCuenta ? "p-error" : ""} type="search" id="restricciones.idCuenta" name="restricciones.idCuenta" value={restricciones.idCuenta || ''} onChange={this.asignarValoresObjeto}></InputText>
                                <label>* Id Cuenta:</label>
                                {errores.idCuenta ? <div> <Message severity="error" text={errores.idCuenta} /> </div> : null}
                            </span>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <span className="md-inputfield">
                                <InputText className={errores.idCliente ? "p-error" : ""} type="search" id="restricciones.idCliente" name="restricciones.idCliente" value={restricciones.idCliente || ''} onChange={this.asignarValoresObjeto}></InputText>
                                <label>* Id Cliente:</label>
                                {errores.idCliente ? <div> <Message severity="error" text={errores.idCliente} /> </div> : null}
                            </span>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <span className="md-inputfield">
                                <InputText className={errores.rfc ? "p-error" : ""} type="search" id="restricciones.rfc" name="restricciones.rfc" value={restricciones.rfc || ''} onChange={this.asignarValoresObjeto}></InputText>
                                <label>* Rfc Cliente:</label>
                                {errores.rfc ? <div> <Message severity="error" text={errores.rfc} /> </div> : null}
                            </span>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <Button label="Buscar" icon="pi-md-search" className="p-button-success" onClick={this.buscar} />
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="p-grid">
                        <div className="p-col-12">
                            <DataTable value={paginacion.datos} header="CFID IAVE" responsive={true} resizableColumns={true}>
                                <Column body={this.templateXml} header="Descarga Xml" />
                                <Column body={this.templatePdf} header="Descarga Pdf" />
                                <Column field="tipoComprobante" header="Tipo" autoLayout={true} resizableColumns={true} />
                                <Column field="serie" header="Serie" autoLayout={true} resizableColumns={true} />
                                <Column field="folio" header="Folio" autoLayout={true} resizableColumns={true} />
                                <Column body={this.templateColumnaFecha} header="Fecha" autoLayout={true} resizableColumns={true} />
                                <Column field="nombre" header="Nombre Cliente" autoLayout={true} resizableColumns={true} />
                                <Column body={this.templateColumnaTotal} header="Total" autoLayout={true} resizableColumns={true} />
                                <Column field="uuid" header="Uuid" autoLayout={true} resizableColumns={true} />
                                <Column field="idCliente" header="Id Cliente" autoLayout={true} resizableColumns={true} />
                                <Column field="idCuenta" header="Id Cuenta" autoLayout={true} resizableColumns={true} />
                                <Column field="periodo" header="Periodo" autoLayout={true} resizableColumns={true} />
                            </DataTable>
                            <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina} rowsPerPageOptions={[20, 40, 60, 80, 100]} />

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}